<template>
    <section class="welcome-banner bg-grey">
        <div class="page-container">
            <div class="welcome-copy">
                <figure class="featured mb-20">
                    <img class="ulta_cc w-25" src="images/single_card.png" alt="">
                </figure>
                <h1 class="txt-black mb-10" >Beyond Ulta Beauty Rewards<sup>&#8482;</sup></h1>
                <p class="txt-black" >More shopping, more points AND cash back! <br> Make the most of your shopping haul when you join the Beyond Ulta Beauty Rewards<sup>&#8482;</sup> Program with deals from all your fave brands</p>
                <p class="txt-black" v-if="$route.name==='register' && false">Earn statement credits shopping at your fave retailers today.</p>
                <div class="button-container" v-if="$route.name!=='register'">
                    <button type="button" v-on:click="openRegister" class="button pink midsize caps wide me-3 mb-4">Register</button>
                    <button type="button" v-on:click="openSignIn" class="button transparent midsize caps wide mb-4 pink_sign_in">Sign In </button>
                </div>
            </div>

            <landing-page-offer-component v-if="offer && offer.OfferId"
                :key="offer.OfferId" :offer="offer"/>

        </div>
    </section>
</template>

<script>

import LandingPageOfferComponent from '../LandingPageOfferComponent.vue';

export default {

    name: "WelcomeBannerComponent",
    components: {
        LandingPageOfferComponent
    },
    props: ['offer'],
    methods: {
        openSignIn: function () {
            this.$router.push('sign_in')
        },
        openRegister: function () {
            this.$router.push('register')
        },
    }
}
</script>

